// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.perks-newsletter-consent-module__container___BOa0F {
  margin: 28px 0 16px;
}

.perks-newsletter-consent-module__content___XZt7p {
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: var(--neutral15);
}

.perks-newsletter-consent-module__label___KeNFS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 16px;
}

.perks-newsletter-consent-module__text___L1vsE {
  text-align: left;
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/walk-through/perks-newsletter-consent.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,mBAAA;AAMF;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,4BAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAMF;;AAHA;EACE,gBAAA;AAMF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `perks-newsletter-consent-module__container___BOa0F`,
	"content": `perks-newsletter-consent-module__content___XZt7p`,
	"label": `perks-newsletter-consent-module__label___KeNFS`,
	"text": `perks-newsletter-consent-module__text___L1vsE`
};
export default ___CSS_LOADER_EXPORT___;
